/**
 * Experiment Hypothesis
 * ---
 * Displaying "Shipping & Delivery Details" on the PDP can increase add-to-cart
 * and checkout conversions by providing customers with clear information
 * about shipping and return policies, reducing uncertainty and hesitation.
 */

function run() {
  const shippingDetails = document.querySelector("[data-shipping-details]");

  if (!shippingDetails) {
    return;
  }

  const client = window.Statsig.instance();

  const experiment = client.getExperiment("pdp_-_add_shipping_modal");
  const showShippingDetails = experiment.get("display_shipping_cta", true); // Second parameter is fallback

  if (!showShippingDetails) {
    return;
  }

  shippingDetails.classList.remove("hidden");
}

if (window?.Statsig?.instance()?.loadingStatus === "Ready") {
  run();
} else {
  window.addEventListener("statsigReady", run);
}
